import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCalendar = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1024 1024",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M884.364 93.091h-46.545v-46.545c0-25.6-20.945-46.545-46.545-46.545s-46.545 20.945-46.545 46.545v46.545h-465.455v-46.545c0-25.6-20.945-46.545-46.545-46.545s-46.545 20.945-46.545 46.545v46.545h-46.545c-51.2 0-93.091 41.891-93.091 93.091v744.727c0 51.2 41.891 93.091 93.091 93.091h744.727c51.2 0 93.091-41.891 93.091-93.091v-744.727c0-51.2-41.891-93.091-93.091-93.091zM837.818 930.909h-651.636c-25.6 0-46.545-20.945-46.545-46.545v-558.545h744.727v558.545c0 25.6-20.945 46.545-46.545 46.545z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgCalendar);
export default ForwardRef;
